export default "__VITE_ASSET__BMEmO5XR__"